import React from "react";

// Chips des filtres actifs : lisibles panneau replié, retirables un à un.
const ActiveFilterChips = ({ chips = [], onRemove, onClear = null, clearLabel = "Tout effacer" }) => {
  if (!chips.length) return null;
  return (
    <div className="chips-bar">
      <ul className="chips" aria-label="Filtres actifs">
        {chips.map((chip) => (
          <li key={chip.name} className="chip">
            <span className="chip__label">
              {chip.label}
              {chip.value ? " :" : ""}
            </span>
            {chip.value && (
              <>
                {" "}
                <span className="chip__value">{chip.value}</span>
              </>
            )}
            <button
              type="button"
              className="chip__remove"
              onClick={() => onRemove(chip.names || chip.name)}
              aria-label={`Retirer le filtre ${chip.label}${chip.value ? " : " + chip.value : ""}`}
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </li>
        ))}
      </ul>
      {onClear && chips.length > 1 && (
        <button type="button" className="btn btn-link btn-sm chips__clear" onClick={onClear}>
          {clearLabel}
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChips;
